

































































import { Component, Vue, Watch } from 'vue-property-decorator'
import PageHead from '@/components/PageHead.vue'
import { Notify } from '@/helpers/Notify'
import { Api } from '@/fetch/Api'
import type { NavItem } from '@/interfaces'
import { VueNestable, VueNestableHandle } from 'vue-nestable'
import store from '@/store'

@Component({
  components: {
    PageHead,
    VueNestable,
    VueNestableHandle,
  },
})
export default class CSRMenu extends Vue {
  pageTitle = 'Menu Manager'
  callInProgress = false
  nav: NavItem[] = null

  mounted() {
    this.fetchDomainNav()
  }

  @Watch('nav')
  onVariable() {
    this.processNav()
  }

  public async fetchDomainNav() {
    this.callInProgress = true
    try {
      const nav = await Api.getDomainNav()
      this.nav = this.preOutputNav(nav.nav)
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public async saveNav() {
    this.callInProgress = true
    try {
      const nav = await Api.setDomainNav(this.nav)
      this.nav = this.preOutputNav(nav)
      this.callInProgress = false
      store.commit('toggleFlag', 'reloadNav')
      Notify.create({
        type: 'success',
        title: 'Saved!',
        text: 'Menu Changes Saved.',
      })
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public pushToNav() {
    this.nav.push({
      id: this.getHighestNavId() + 1,
      is_menu: false,
      page_title: 'New Page',
      page_id: null,
      menu_title: null,
      hidden: false,
      children: [],
    })
  }

  public deleteNav(item) {
    for (const first_level of this.nav) {
      if (item.id === first_level.id) {
        // delete first level item, but append children if there were any
        this.deleteFirstLevelNav(item)
      }
      if (first_level.children.length > 0) {
        for (const [index, second_level] of first_level.children.entries()) {
          // delete second level item
          if (item.id === second_level.id) {
            first_level.children.splice(index, 1)
          }
        }
      }
    }
  }

  private deleteFirstLevelNav(item) {
    for (const [index, first_level] of this.nav.entries()) {
      if (item.id === first_level.id) {
        // delete first level item, but append children if there were any
        if (first_level.children.length > 0) {
          for (const second_level of first_level.children.reverse()) {
            // inserting children elements right after parent el index
            this.nav.splice(index + 1, 0, second_level)
          }
        }
        this.nav.splice(index, 1)
      }
    }
  }

  public dragPrevent(event) {
    event.preventDefault()
    event.stopPropagation()
  }

  private getHighestNavId() {
    let highestId = 0
    for (const first_level of this.nav) {
      highestId = (first_level.id > highestId) ? first_level.id : highestId
      if ('children' in first_level) {
        for (const second_level of first_level.children) {
          highestId = (second_level.id > highestId) ? second_level.id : highestId
        }
      }
    }
    return highestId
  }

  private preOutputNav(nav) {
    for (const first_level of nav) {
      if (first_level.children.length > 0) {
        // moving first children page attributes to a parent element
        first_level.page_id = first_level.children[0].page_id
        first_level.page_title = first_level.children[0].page_title
        // removing first children element
        first_level.children.splice(0, 1)
      }
    }
    return nav
  }

  private processNav() {
    for (const first_level of this.nav) {
      // if first level item gets children - it'll be update as "is_menu"=true and receives a menu_title of itself
      if (first_level.children.length > 0 && !first_level.is_menu) {
        first_level.is_menu = true
        first_level.menu_title = first_level.page_title
      }

      // if first level item looses all children - it'll be update as "is_menu"=false and  menu_title removed
      if (first_level.children.length === 0 && first_level.is_menu) {
        first_level.is_menu = false
        first_level.menu_title = null
      }
    }
  }
}

